'use strict';

const urlHelper = require('../utils/urlHelper');
const phoneUtils = require('friartux/utils/phone');
const regex = require('../utils/regex');
const { CLASSES } = require('friartux/utils/globals');
const SELECTORS = {
    body: 'body',
    sharedCodeForm: '.js-shared-code-form',
    sharedCodeInput: '.js-shared-code-input',
    checkOrderStatusForm: '.js-check-order-status-form',
    checkOrderStatusInput: '.js-check-order-status-input',
    sharedCodeTabBtn: '.js-shared-code-tab-btn',
    emailOrPhoneTabBtn: '.js-email-or-phone-tab-btn',
    eventDetailsTabBtn: '.js-event-details-tab-btn',
    sharedLookupBackBtn: '.js-shared-code-lookup-back-btn',
    sharedLookupTypeHiddenInput: '#lookuptype',
    shareCodeLookupSubmitBtn: '.js-event-lookup-submit-btn',
    shareCodeLookupFormInput: '.js-share-code-lookup-input',
    eventDetailsLookUpPhoneEmailInput: '.js-event-details-phone-email-input',
    shareCodeLookupFormInputError: '.js-share-code-missing-error',
    shareCodeLookupFormInputInvalidError: '.js-share-code-invalid-error',
    invalidMessage: '.f-invalid-message',
    activeTab: '.tab-pane.active',

    eventRegistrationDateInput: '.js-event-registration-date-input',
    eventRegistrationFirstNameInput: '.js-event-registration-first-name-input',
    eventRegistrationLastNameInput: '.js-event-registration-last-name-input',
    eventRegistrationPhoneNumberInput: '.js-event-registration-phone-number-input',

    shareCodeLookupContainer: '#sharecodelookup',
    emailOrMobileLookupContainer: '#eventdetailslookup',
    eventRegistrationLookupContainer: '#eventregistrationlookup',
    shareCodeLookupTabMenu: '#lookupmenu',

    eventDetailsLookUpEventDataInput: '.js-event-details-event-date-input',

    eventRegistrationOrganizerLastNameInput: '.js-event-registration-organizer-last-name-input',


    eventLookUpModal: '#eventlookup',
    eventConfirmModal: '#eventconfirm',
    eventConfirmSubmit: '.js-event-confirm-submit',
    eventConfirmCancelBtn: '.js-event-cancel-button',
    eventConfirmName: '.js-confirm-name',
    eventConfirmDate: '.js-event-confirm-date',
    lookBuilder: '.look-builder',

    modalContent: '.modal-content'

};

/**
 * Test given string if alphanumeric.
*/
function isAlphaNumeric(str) {
    var regexp = RegExp(/^([a-zA-Z0-9_-]+)$/i);

    return regexp.test(str);
}

const handleSharedLookupMenu = () => {
    $(SELECTORS.shareCodeLookupContainer).addClass(CLASSES.hide);
    $(SELECTORS.emailOrMobileLookupContainer).addClass(CLASSES.hide);
    $(SELECTORS.eventRegistrationLookupContainer).addClass(CLASSES.hide);

    $(SELECTORS.sharedLookupTypeHiddenInput).val('');
    $(SELECTORS.shareCodeLookupTabMenu).removeClass(CLASSES.hide);
}

const handleSharedCodeLookupTab = () => {
    $(SELECTORS.shareCodeLookupTabMenu).addClass(CLASSES.hide);
    $(SELECTORS.sharedLookupTypeHiddenInput).val('sharecode');
    $(SELECTORS.shareCodeLookupContainer).removeClass(CLASSES.hide);
}

const handleEmailOrPhoneLookupTab = () => {
    $(SELECTORS.shareCodeLookupTabMenu).addClass(CLASSES.hide);
    $(SELECTORS.sharedLookupTypeHiddenInput).val('emailphone');
    $(SELECTORS.emailOrMobileLookupContainer).removeClass(CLASSES.hide);
}

const handleEventDetailsLookupTab = () => {
    $(SELECTORS.shareCodeLookupTabMenu).addClass(CLASSES.hide);
    $(SELECTORS.sharedLookupTypeHiddenInput).val('eventdetails');
    $(SELECTORS.eventRegistrationLookupContainer).removeClass(CLASSES.hide);
}

const handleSharedCodeLookupForm = (e) => {
    const $this = $(e.target);
    e.preventDefault();
    let shareCode = '';
    let eventDate = '';
    let eventEmail = '';
    let eventRegistrationDate = '';
    let eventOrganizerLastName = '';
    let eventRegistationFName = '';
    let eventRegistationLName = '';
    let eventPhoneNumber = '';
    let isValid = true;

    let lookupType = $(SELECTORS.sharedLookupTypeHiddenInput).val().trim();
    $(SELECTORS.shareCodeLookupFormInput).parent().removeClass(CLASSES.isInvalid);
    $(SELECTORS.activeTab).find(SELECTORS.invalidMessage).addClass(CLASSES.hide);

    var $lookupResultContainer = $('.order-status-container-' + lookupType);
    $lookupResultContainer.empty();

    if (lookupType == 'sharecode') {
        shareCode = $(SELECTORS.shareCodeLookupFormInput).val().trim();

        if (!$(SELECTORS.shareCodeLookupFormInput).val() || $(SELECTORS.shareCodeLookupFormInput).val().trim() === '') {
            $(SELECTORS.shareCodeLookupFormInput).parent().addClass(CLASSES.isInvalid);
            $(SELECTORS.shareCodeLookupFormInputError).removeClass(CLASSES.hide);
            return false;
        }

        isValid = regex.test('alphaNumeric', shareCode);

        if (!isValid) {
            $(SELECTORS.shareCodeLookupFormInput).parent().addClass(CLASSES.isInvalid);
            $(SELECTORS.shareCodeLookupFormInputInvalidError).removeClass(CLASSES.hide);

            return false;
        }
    }

    if (lookupType == 'emailphone') {
        eventDate = $(SELECTORS.eventDetailsLookUpEventDataInput).val().trim();
        eventEmail = $(SELECTORS.eventDetailsLookUpPhoneEmailInput).val().trim();
        eventPhoneNumber = $(SELECTORS.eventRegistrationPhoneNumberInput).val().trim();

        if (!eventEmail && !eventPhoneNumber) {
            $lookupResultContainer.html('Please enter your email address or phone number');
            $lookupResultContainer.removeClass(CLASSES.hide);

            return;
        }

        if (eventEmail) {
            isValid = regex.test('email', eventEmail);
            if (!isValid) {
                let $fieldContainer = $(SELECTORS.eventDetailsLookUpPhoneEmailInput).parent();
                $fieldContainer.addClass(CLASSES.isInvalid);
                $fieldContainer.siblings('.error').find(SELECTORS.invalidMessage).removeClass(CLASSES.hide);

                return false;
            }
        }

        if (eventPhoneNumber) {
            isValid = regex.test('phone', eventPhoneNumber);
            if (!isValid) {
                let $fieldContainer = $(SELECTORS.eventRegistrationPhoneNumberInput).parent();
                $fieldContainer.addClass(CLASSES.isInvalid);
                $fieldContainer.siblings('.error').find(SELECTORS.invalidMessage).removeClass(CLASSES.hide);

                return false;
            }
        }

        if (eventDate.length < 1) {
            $lookupResultContainer.html('Please fill the Event Date');
            $lookupResultContainer.removeClass(CLASSES.hide);

            return;
        }
    }

    if (lookupType == 'eventdetails') {
        eventRegistrationDate = $(SELECTORS.eventRegistrationDateInput).val().trim();
        eventOrganizerLastName = $(SELECTORS.eventRegistrationOrganizerLastNameInput).val().trim();
        eventRegistationFName = $(SELECTORS.eventRegistrationFirstNameInput).val().trim();
        eventRegistationLName = $(SELECTORS.eventRegistrationLastNameInput).val().trim();

        if (!eventRegistationFName || !eventRegistationLName || !eventOrganizerLastName) {
            $lookupResultContainer.html('Please fill the mandatory fields');
            $lookupResultContainer.removeClass(CLASSES.hide);

            return;
        }

        if (!regex.test('name', eventOrganizerLastName)
            || !regex.test('name', eventRegistationFName)
            || !regex.test('name', eventRegistationLName)) {
                $lookupResultContainer.html('Invalid characters; please remove');
                $lookupResultContainer.removeClass(CLASSES.hide);

                return;
        }
    }

    $this.attr('disabled', true);
    $.ajax({
        url: Urls.shareCodeLookup,
        type: 'post',
        dataType: 'json',
        data: {
            lookupType: lookupType,
            shareCode: shareCode,
            eventDate: eventDate,
            eventEmailOrPhone: eventEmail,
            eventRegistrationDate: eventRegistrationDate,
            eventOrganizerLastName: encodeURIComponent(eventOrganizerLastName),
            eventRegistationFName: encodeURIComponent(eventRegistationFName),
            eventRegistationLName: encodeURIComponent(eventRegistationLName),
            eventRegistationPhoneNumber: eventPhoneNumber,
        },
        success: function (data) {
            $this.attr('disabled', false);
            if (data.success == 'true' || data.success == true) {
                openConfirmModal(data);
            } else {
                $lookupResultContainer.removeClass(CLASSES.hide);
                $lookupResultContainer.html(data.message);

                setTimeout(() => {
                    $lookupResultContainer.html(data.message);
                }, 500);
            }
        },
        error: function (err) {
            $this.attr('disabled', false);
            $lookupResultContainer.html(err.message);
            $lookupResultContainer.removeClass(CLASSES.hide);
        }
    });
}

const handleCheckOrderStatusFormSubmit = (e) => {
    e.preventDefault();

    var $ordersStatusContainer = $('.order-status-container');
    $ordersStatusContainer.empty();
    const $form = $(e.target);
    let url = $form.attr('action');
    let orderNumber = $(SELECTORS.checkOrderStatusInput).val().trim();

    $(this).attr('disabled', true);
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            orderId: orderNumber
        },
        success: function (data) {
            $ordersStatusContainer.html(data.message);
            $.spinner().stop();
        },
        error: function (err) {
            $ordersStatusContainer.html(err.message);
            $.spinner().stop();
        }
    });
}

/**
 * Ajax call to 'Cart-Show' endpoint
 * @returns {void}
 */
const handleSharedCodeFormSubmit = (e) => {
    e.preventDefault();

    const $form = $(e.target);
    let url = $form.attr('action');
    let sharedCode = $(SELECTORS.sharedCodeInput).val().trim();

    if (!sharedCode || sharedCode === '' || !isAlphaNumeric(sharedCode)) {
        return;
    }

    url = urlHelper.appendToUrl(url, {
        sharedCode
    });

    $.spinner().start();
    window.location.href = url;
}

/**
 * Show a confirmation modal of event.
 */
const openConfirmModal = (data) => {
    $(SELECTORS.eventConfirmName).text(data.memberName);
    $(SELECTORS.eventConfirmDate).text(data.eventDate);
    $(SELECTORS.eventConfirmModal).modal('show');
    $(SELECTORS.eventConfirmSubmit).data('redirecto', data.redirecto);

    if (data.cancelRedirect) {
        $(SELECTORS.eventConfirmCancelBtn).data('redirecto', data.cancelRedirect);
    }

    $(SELECTORS.eventConfirmModal)
        .find(SELECTORS.modalContent);

    $(SELECTORS.eventConfirmModal)
        .find('.modal-body')
        .addClass('my-auto');
}

/**
 * Handle the event confirm submit.
 *
 * @param {*} e - event
 */
const handleEventConfirmSubmit = (e) => {
    const $submitButton = $(e.target);
    const redirecto = $submitButton.data('redirecto');

    if (redirecto) {
        window.location = redirecto;
    }
}

function pageLoadEvents() {
    if (SELECTORS.lookBuilder.length) {
        const $lookBuilder = $(SELECTORS.lookBuilder);
        const showEventConfirmation = $lookBuilder.data('show-event-confirmation-modal')
        const eventDetail = $lookBuilder.data('event-detail');
        if (showEventConfirmation) {
            openConfirmModal(eventDetail);
        }
    }

    const urlParams = new URLSearchParams(window.location.search);
    const openFindShareOrderModal = urlParams.get('find-order');
    if (openFindShareOrderModal) {
        $(SELECTORS.eventLookUpModal).modal('show');
    }
}

const initEvents = () => {
    $(SELECTORS.sharedCodeForm).on('submit', handleSharedCodeFormSubmit);
    $(SELECTORS.sharedCodeInput).on('focusout', () => {
        $(SELECTORS.sharedCodeForm).trigger('submit');
    });
    $(SELECTORS.checkOrderStatusForm).on('submit', handleCheckOrderStatusFormSubmit);
    $(SELECTORS.sharedCodeTabBtn).on('click', handleSharedCodeLookupTab);
    $(SELECTORS.emailOrPhoneTabBtn).on('click', handleEmailOrPhoneLookupTab);
    $(SELECTORS.eventDetailsTabBtn).on('click', handleEventDetailsLookupTab);
    $(SELECTORS.sharedLookupBackBtn).on('click', handleSharedLookupMenu);
    $(SELECTORS.shareCodeLookupSubmitBtn).on('click', handleSharedCodeLookupForm);
    $(SELECTORS.body).on('keyup', SELECTORS.shareCodeLookupFormInput, (e) => {
        if (e.key === 'Enter') {
            $(e.target)
                .closest('.lookup-code-wrapper')
                .find(SELECTORS.shareCodeLookupSubmitBtn)
                .trigger('click');
        }
    });

    $(SELECTORS.body).on('click', SELECTORS.eventConfirmSubmit, handleEventConfirmSubmit);
    $(SELECTORS.body).on('click', SELECTORS.eventConfirmCancelBtn, handleEventConfirmSubmit);

    // Event-date calendars are initialised by components/inputDate.js (accessible ab-datepicker).

    phoneUtils.formatPhone(SELECTORS.eventRegistrationPhoneNumberInput);

    pageLoadEvents();
};

module.exports = () => {
    initEvents();
};
